module.exports = __webpack_public_path__ + "img/Euclid.f779c3ee.png";